module.exports = __webpack_public_path__ + "img/add-button.0bc57e9f.svg";